/**
 * Маппинг ошибок входа команды в человекочитаемый текст.
 * BE отдаёт `invalid_credentials` (ADMIN_BACKEND_SPEC §2) — переводим.
 */

export const mapAuthError = (err: unknown): string => {
  const msg = err instanceof Error ? err.message : String(err);
  const status = (err as {status?: number}).status;
  if (msg.includes('no_platform_access')) {
    return 'Аккаунт без доступа к платформе — вход только для команды Skrezo';
  }
  if (msg.includes('invalid_credentials') || status === 401) {
    return 'Неверный телефон или пароль';
  }
  return 'Не удалось войти. Попробуйте ещё раз';
};
